import { render, staticRenderFns } from "./VueImage.vue?vue&type=template&id=d11794aa&"
import script from "./VueImage.vue?vue&type=script&lang=js&"
export * from "./VueImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports